import { useRef, useState } from 'react';
import { uploadFile } from '../../lib/storage';

const ACCEPT = '.jpg,.jpeg,.png,.pdf,.doc,.docx,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export default function FileUploader({ onUpload, existingFiles = [], onDelete }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (file) => {
    if (!file) return;
    setError('');
    setUploading(true);
    try {
      const url = await uploadFile('attachments', 'files', file);
      onUpload({ url, name: file.name, type: file.type });
    } catch (err) {
      setError(err.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-brand-dark">Attachments</label>

      {existingFiles.length > 0 && (
        <ul className="space-y-2">
          {existingFiles.map((file) => (
            <li
              key={file.id}
              className="flex items-center justify-between gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
            >
              <a
                href={file.file_url}
                target="_blank"
                rel="noreferrer"
                className="text-sm text-brand-purple hover:underline truncate"
              >
                {file.file_name}
              </a>
              <button
                type="button"
                onClick={() => onDelete(file.id)}
                className="text-xs text-red-600 hover:text-red-800 shrink-0"
              >
                Delete
              </button>
            </li>
          ))}
        </ul>
      )}

      <div>
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPT}
          className="hidden"
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
        <button
          type="button"
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
          className="text-sm px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
        >
          {uploading ? 'Uploading…' : '+ Add file'}
        </button>
        <p className="text-xs text-gray-400 mt-1">JPG, PNG, PDF, DOC, DOCX</p>
      </div>

      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
}
